import { render, staticRenderFns } from "./InfoEvaluations.vue?vue&type=template&id=4e45ae6a&scoped=true"
import script from "./InfoEvaluations.vue?vue&type=script&lang=js"
export * from "./InfoEvaluations.vue?vue&type=script&lang=js"
import style0 from "./InfoEvaluations.vue?vue&type=style&index=0&id=4e45ae6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e45ae6a",
  null
  
)

export default component.exports